<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="config"/>
          {{ $t('title') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')"></b-form-input>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <!-- c-paging -->
      <div class="col-12">
        <div class="c-sorting">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
            <!-- col -->
          </div>
          <!-- row -->
        </div>
        <!-- c-sorting -->
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- c-paging -->
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-2">{{ $t('clientSource') }}</div>
            <div class="col-lg-2">{{ $t('new') }}</div>
            <div class="col-lg-2">{{ $t('user') }}</div>
            <div class="col-lg-2">{{ $t('extend') }}</div>
            <div class="col-lg-2">{{ $t('upgrade') }}</div>
            <div class="col-lg-2"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-2">
              <b class="c-smart-table__label">{{ $t('clientSource') }}: </b>
              <span>{{ $t(item.clientSource) }}</span>
            </div>
            <div class="col-lg-2">
              <b class="c-smart-table__label">{{ $t('new') }}: </b>
              <span>{{ item.new }}%</span>
            </div>
            <div class="col-lg-2">
              <b class="c-smart-table__label">{{ $t('user') }}: </b>
              <span>{{ item.user }}%</span>
            </div>
            <div class="col-lg-2">
              <b class="c-smart-table__label">{{ $t('extend') }}: </b>
              <span>{{ item.extend }}%</span>
            </div>
            <div class="col-lg-2">
              <b class="c-smart-table__label">{{ $t('upgrade') }}: </b>
              <span>{{ item.upgrade }}%</span>
            </div>
            <div class="col-lg-2">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col">
                    <button @click="update(item._id)" type="button"
                            class="btn btn-sm btn-info mr-1">
                      <font-awesome-icon icon="edit"/>&nbsp;{{ $t('edit') }}
                    </button>
                    <button @click="del(item._id)" type="button" class="btn btn-sm btn-danger mr-1">
                      <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal v-model="showForm" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
      <form-input :label="$t('clientSource')" :model="formModel" attribute="clientSource" :errors="formErrors"></form-input>
      <form-input :label="$t('new')" :model="formModel" attribute="new" :errors="formErrors">
      </form-input>
      <form-input :label="$t('user')" :model="formModel" attribute="user" :errors="formErrors">
      </form-input>
      <form-input :label="$t('extend')" :model="formModel" attribute="extend" :errors="formErrors">
      </form-input>
      <form-input :label="$t('upgrade')" :model="formModel" attribute="upgrade" :errors="formErrors">
      </form-input>
    </b-modal>
  </main>
</template>
<script>

import List from '@/mixins/List';
import CRUD from '@/mixins/CRUD';

export default {
  mixins: [List, CRUD],
  data: function () {
    return {
      service: '/commission-config',
      defaultFormModel: {},
      autoLoad: true
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'Commission config',
        new: 'Buy new',
        user: 'Buy more user',
        upgrade: 'Upgrade',
        extend: 'Extend',
        chooseSource: 'Choose source',
        agency: 'Agency',
        clientSource: 'Client source',
        default: 'Default'
      },
      vi: {
        title: 'Cấu hình hoa hồng cho sales',
        new: 'Mua mới',
        user: 'Mua thêm user',
        upgrade: 'Nâng cấp',
        extend: 'Gia hạn',
        chooseSource: 'Chọn nguồn',
        agency: 'Đại lý / CTV',
        clientSource: 'Nguồn khách',
        default: 'Mặc định'
      }
    }
  },
  methods: {}
}
</script>